import { defineComponent } from 'vue'

import { Wemi } from '@skinsoft/types'
import { itemSelectors } from '@skinsoft/selectors'
import { AuditCampaignPopUp } from './audit-campaign-pop-up'
import { ItemEditScreen } from '@skinsoft/entity-ui/src/item/components/item-edit-screen'
import { OPEN_AUDIT_CAMPAIGN_POP_UP } from '../../../busTopics'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'


export const AuditItemEditScreen = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        auditCampaignPopUp: AuditCampaignPopUp,
        sItemEditScreen: ItemEditScreen,
    },
    props: ['itemId', 'headerTitle', 'navigateBackRoute'],
    template: require('./audit-item-edit-screen.html'),
    data() {
        return {
            auditCampaignPopUp: false,
        }
    },
    mounted() {
        this.subscribeToBus(OPEN_AUDIT_CAMPAIGN_POP_UP, this.toggleAuditCampaignPopUp)
    },
    methods: {
        toggleAuditCampaignPopUp() {
            this.auditCampaignPopUp = !this.auditCampaignPopUp
        },
        linkableItemType(entity: Wemi | undefined): string {
            return entity?.item ? itemSelectors.type(entity.item) : ''
        },
    },
})
